import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { KeyRound, Copy, Unlink, Monitor } from 'lucide-react';
import { paidToken, pcCodeGet, pcCodeRelease, pcActivate, pcLicense } from '../lib/license';

const GM = /^[a-z0-9.+_-]{3,64}@(gmail|googlemail)\.com$/i;
const err = (t, e) => toast.error(t['pcErr_' + e.message] || t.licOffline);

// phone: create personal PC code (gmail-bound) / office PC: activate with gmail + code
export default function PcUnlock({ t, onChange }) {
  const paid = !!paidToken();
  const [info, setInfo] = useState(null);
  const [mail, setMail] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (paid) pcCodeGet().then((d) => { setInfo(d); setMail(d.email); }).catch(() => {}); }, [paid]);
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { err(t, e); } setBusy(false); };
  const create = () => run(async () => { setInfo(await pcCodeGet(mail.trim())); toast.success(t.pcCreated); });
  const release = () => run(async () => { setInfo(await pcCodeRelease()); toast.success(t.pcReleased); });
  const activate = () => run(async () => { await pcActivate(mail.trim(), code.trim()); toast.success(t.pcActivated); onChange?.(); });
  const pc = pcLicense();
  return (
    <div className="pc-unlock" data-testid="pc-unlock">
      <b><Monitor size={15} /> {paid ? t.pcTitlePhone : t.pcTitlePc}</b>
      <p className="muted small-hint">{paid ? t.pcHintPhone : t.pcHintPc}</p>
      {pc && <p className="lic-line ok" data-testid="pc-active">✅ {t.pcActiveHere} ({pc.code})</p>}
      <div className="row">
        <input type="email" inputMode="email" data-testid="pc-gmail-input" placeholder="name@gmail.com" value={mail} onChange={(e) => setMail(e.target.value)} />
        {!paid && <input type="text" data-testid="pc-code-input" placeholder="GISS-PC-XXXX-XXXX" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} />}
        {paid
          ? <button className="btn btn-dark btn-sm" data-testid="pc-create-btn" disabled={busy || !GM.test(mail.trim())} onClick={create}><KeyRound size={14} /> {info ? t.pcUpdate : t.pcCreate}</button>
          : <button className="btn btn-green btn-sm" data-testid="pc-activate-btn" disabled={busy || !GM.test(mail.trim()) || code.length < 17} onClick={activate}><KeyRound size={14} /> {t.pcActivate}</button>}
      </div>
      {paid && info && (
        <div className="pc-code-box" data-testid="pc-code-box">
          <span>🔑 <b className="mono" data-testid="pc-code-value">{info.code}</b> · {info.email}</span>
          <button className="btn btn-outline btn-sm" data-testid="pc-code-copy-btn" onClick={() => navigator.clipboard?.writeText(`${info.email} / ${info.code}`).then(() => toast.success(t.shCopied))}><Copy size={13} /> {t.copy}</button>
          <small data-testid="pc-bound-status">{info.pc_device ? `${t.pcBound}: ${info.pc_device}` : t.pcFree}</small>
          {info.pc_device && <button className="btn btn-outline btn-sm" data-testid="pc-release-btn" disabled={busy} onClick={release}><Unlink size={13} /> {t.pcRelease}</button>}
        </div>
      )}
    </div>
  );
}
